export const floatingCollisionPadding = 8;

export const floatingLayerClassName = "bfrs-z-[1000]";

export const dropdownContentCollisionClassName =
  "bfrs-max-h-[min(24rem,var(--radix-dropdown-menu-content-available-height))] bfrs-overflow-auto";

export const popoverContentCollisionClassName =
  "bfrs-max-h-[min(32rem,var(--radix-popover-content-available-height))] bfrs-max-w-[calc(100vw-1rem)] bfrs-overflow-auto";

export const selectContentCollisionClassName =
  "bfrs-max-h-[min(20rem,var(--radix-select-content-available-height))]";

export const searchableSelectContentCollisionClassName =
  "bfrs-max-h-[min(18rem,var(--radix-popover-content-available-height))] bfrs-w-[var(--radix-popover-trigger-width)] bfrs-overflow-hidden";

export const searchableSelectListboxCollisionClassName =
  "bfrs-max-h-[min(14rem,max(4rem,calc(var(--radix-popover-content-available-height)-3rem)))] bfrs-overflow-auto";

export const multiSelectListboxCollisionClassName =
  "bfrs-min-h-0 bfrs-flex-1 bfrs-max-h-[min(14rem,max(3rem,calc(var(--radix-popover-content-available-height)-6.5rem)))] bfrs-overflow-auto";

export const tooltipContentCollisionClassName =
  "bfrs-max-w-[min(16rem,var(--radix-tooltip-content-available-width))]";
